import React, { useState, useEffect } from 'react'
import { Table, Panel, Row, Whisper, Tooltip } from 'rsuite'
import { Icon, IconButton, ButtonGroup } from 'rsuite'
import { budgetFormat, numberThousandSeparator } from '../../../utils/formatterUtil'

export default function ActivityCostTableView({
  schema: _schema,
  onEdit,
  showCommandButton,
  ...props
}) {
  const { Column, HeaderCell, Cell, ColumnGroup } = Table

  const [dataList, setDatalist] = useState([])
  const [summary, setSummary] = useState([])
  const [schema, setSchema] = useState(_schema)

  useEffect(() => {
    let schemaValue = [..._schema?.value]
    let activityList = []
    let totalBudget = 0

    schemaValue.forEach((activity, index) => {
      // console.log('activity ', activity)
      let activityBudget = 0

      let obj = {
        activity: activity,
        activityStr: activity.activity,
        index: index,
        // budgetId: '',
        // bugetDetail: '',
        // numberUnits: '',
        // unitPrice: '',
        // totalBudget: '',
      }

      activityList.push(obj)

      if (activity?.activityBudget?.length > 0) {
        activity?.activityBudget?.forEach((buget, budgetIndex) => {
          // console.log('buget ', buget)
          let obj = {
            // activity: budgetIndex == 0 ? activity : '',
            index: index,
            budgetId: buget.id,
            bugetDetail: buget.detail,
            numberUnits: buget.count,
            unitPrice: buget.unitPrice,
            totalBudget: buget.sumPrice,
          }

          activityBudget += buget.sumPrice
          activityList.push(obj)
        })
        // } else {
        //   let obj = {
        //     activity: activity,
        //     index: index,
        //     budgetId: '',
        //     bugetDetail: '',
        //     numberUnits: '',
        //     unitPrice: '',
        //     totalBudget: '',
        //   }
        //   activityList.push(obj)
      }

      totalBudget += activityBudget
      activityList.push({
        numberUnits: `รวมกิจกรรมที่ ${index + 1}`,
        totalBudget: activityBudget,
        isStong: true,
      })
    })

    setSchema(_schema)
    setDatalist(activityList)
    setSummary([{ numberUnits: `รวมค่าใช้จ่าย`, totalBudget: totalBudget, isStong: true }])
  }, [_schema])

  return (
    <Panel eventKey={2} bodyFill>
      {schema.activity && (
        <Row>
          <Table
            rowKey="id"
            height={400}
            autoHeight={dataList.length <= 5}
            wordWrap={true}
            data={dataList}
            // cellBordered
          >
            <Column width={200} fixed="left" colSpan={2}>
              <HeaderCell>{schema.activity.label}</HeaderCell>
              <Cell dataKey="activityStr" />
            </Column>

            <Column minWidth={200} flexGrow={1}>
              <HeaderCell>รายละเอียดค่าใช้จ่าย</HeaderCell>
              <Cell dataKey="bugetDetail" />
            </Column>

            <Column width={150} align="right" colSpan={3}>
              <HeaderCell>ราคาต่อหน่วย</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.activityStr) {
                    return (
                      !rowData.isStong && (
                        <ButtonGroup>
                          <IconButton
                            appearance="ghost"
                            className="rs-btn-ghost-edit"
                            icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                            onClick={(e) => {
                              onEdit(rowData)
                            }}
                          >
                            เพิ่ม/แก้ไขผลผลิตและงบประมาณดำเนินโครงการ
                          </IconButton>
                        </ButtonGroup>
                      )
                    )
                  } else {
                    return budgetFormat(rowData.unitPrice)
                  }
                }}
              </Cell>
            </Column>
            <Column width={140} align="right" fixed="right">
              <HeaderCell>จำนวนหน่วย</HeaderCell>
              <Cell>
                {(rowData) => {
                  return rowData.isStong ? (
                    <b>{numberThousandSeparator(rowData.numberUnits)}</b>
                  ) : (
                    numberThousandSeparator(rowData.numberUnits)
                  )
                }}
              </Cell>
            </Column>
            <Column width={120} align="right" fixed="right">
              <HeaderCell>จำนวนเงิน</HeaderCell>
              <Cell>
                {(rowData) => {
                  return rowData.isStong ? (
                    <b>{budgetFormat(rowData.totalBudget)}</b>
                  ) : (
                    budgetFormat(rowData.totalBudget)
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </Row>
      )}

      <Row style={{ alignContent: 'rigth' }}>
        <Table rowKey="id" autoHeight wordWrap={true} data={summary} showHeader={false}>
          <Column minWidth={1} flexGrow={1}>
            <HeaderCell></HeaderCell>
            <Cell></Cell>
          </Column>
          <Column width={140} align="right" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData) => {
                return <b>{rowData.numberUnits}</b>
              }}
            </Cell>
          </Column>

          <Column width={120} align="right" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData) => {
                return <b>{budgetFormat(rowData.totalBudget)}</b>
              }}
            </Cell>
          </Column>

          <Column width={60} align="center" fixed="right" verticalAlign="middle">
            <HeaderCell></HeaderCell>
            <Cell></Cell>
          </Column>
        </Table>
      </Row>
    </Panel>
  )
}
